import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

export default function Canvas({
  show,
  setShow,
  placement,
  backdrop,
  width = 300,
  bgColor,
  children
}) {
  // console.log("color", bgColor);
  return (
    <div>
      <Offcanvas
        show={show}
        onHide={() => {
          setShow(false);
        }}
        placement={placement}
        backdrop={backdrop}
        scroll={backdrop == true ? false : true}
        style={{ backgroundColor: bgColor, width: width }}
      >
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
